
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import szlovak from "../../assets/szlovak.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function SzlovakMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Szlovák magyar fordító</title>
                <meta name='description' content="Ingyenes szlovák magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Szlovák magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/szlovak-magyar-fordito" />
            </Helmet>
            <h1>Szlovák magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A szlovák nyelvről</h2>
                    <img src={szlovak} alt="Szlovák zászló"></img>
                </div>


                <p>A szlovák egy nyugatszláv nyelv, amelyet elsősorban Szlovákiában beszélnek. Az Európai Unió egyik hivatalos nyelveként is elismert. A szlovák zeneiségéről, gazdag ragozási rendszeréről és más szláv nyelvekkel való szoros kapcsolatáról ismert.</p>

                <p>A szlovák írásrendszer a latin ábécét használja diakritikus jelekkel. 46 betűből áll, beleértve a további karaktereket is, például á, č, ď, é, í, ĺ, ľ, ň, ó, ô, ŕ, š, ť, ú, ý és ž. A szlovák kiejtés általában fonetikus, a betűk és a hangok egy az egyben megfelelnek.</p>

                <p>A szlovák nyelvtan főnévi ragozásokat, igeragozásokat és nyelvtani eseteket tartalmaz. A főnevek, melléknevek és névmások megváltoztatják alakjukat, hogy jelezzék a nemet, a számot és a kisbetűt. A szlovák nyelvnek hét esete van: névelő, genitivus, datívus, accusative, lokative, instrumental és vocative. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>A szlovák szókincs szláv gyökerekkel rendelkezik, és más nyelvekből, különösen németből, magyarból és angolból is beépített kölcsönszavakat. A szlovák irodalom gazdag hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Martin Kukučín, Milan Rúfus és Dominik Tatarka. A szlovák kultúra különféle hagyományokat, népszokásokat, zenét és kulináris különlegességeket ölel fel.</p>

                <p>A szlovák nyelvtudás számos lehetőséget kínál. Szlovákia gazdasága növekszik, különösen az olyan ágazatokban, mint a gyártás, az autóipar, az IT és a turizmus. A szlovák nyelvtudás előnyt jelenthet az ezen a területen végzett pályafutáshoz, illetve a szlovákiai tanulás vagy munka iránt érdeklődők számára.</p>

                <p>A szlovák nyelv a közép-európai kulturális felfedezéshez és utazáshoz is hasznos. Lehetővé teszi a kommunikációt és a kulturális elmélyülést a szlovák nyelvű közösségekben, és megkönnyíti a kapcsolatokat a szomszédos országokkal, például Csehországgal, Lengyelországgal, Magyarországgal és Ausztriával.</p>

                <p>Sőt, a szlovák nyelv tanulása ajtót nyit Szlovákia kulturális örökségéhez és hagyományaihoz. Lehetővé teszi a szlovák társadalom, szokások és értékek mélyebb megértését. A szlovák folklór, zene és irodalom bemutatja az ország gazdag kulturális örökségét.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-szlovak-fordito">Magyar szlovák fordító</Link>

                    <img src={szlovak} alt="szlovák zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default SzlovakMagyar;